// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-product-upload-dragdrop{padding:25px;display:flex;flex-direction:column;align-items:center;gap:10px}.request-product-upload-dragdrop .uk-icon{color:#0000001a}.request-product-upload-dragdrop a{text-decoration:underline}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
